import React, { useEffect, useLayoutEffect, useState, useRef } from 'react'
import { View, Text, ImageBackground, ScrollView, Dimensions, Alert, TouchableWithoutFeedback, Platform, TouchableOpacity } from 'react-native'
import type { ComponentType, ComponentPropsWithRef } from 'react'

import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { Ionicons, Feather } from '@expo/vector-icons'
import styles from './GamificationStyles'
import theme from '../../../theme'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import { getData } from '../appBar/context/HeaderContext'
import { eventEmitter } from '../../utils/functions.utils'
import { Loader } from '../customUtils/Components/Loader'
import { GAMIFICATION_STATUS_KEYS, GAMIFICATION_TYPES_KEYS } from './constants/constants.gamification'
import { useGamification } from './context/gamification.context'
import { LinearGradient } from 'expo-linear-gradient'
import { GamificationAnimatedBackground } from './GamificationAnimatedBackground'
import { GamificationRoulette } from './GamificationRoulette'
import { useIsFocused } from '@react-navigation/native'
import { Step } from '../customUtils/Components/Step'
import { Image } from 'expo-image'
import { GamificationTheme, JackPotGradient, pointsGradientCurrent, pointsGradientDisabled, pointsGradientEnabled } from '../../../themeConstants'

// Importaciones condicionales para reanimated (no disponible en web)
let CustomScroll: ComponentType<ComponentPropsWithRef<typeof ScrollView>>
let CustomView: ComponentType<ComponentPropsWithRef<typeof View>>
let Animated: any
let useAnimatedRef: any
let useAnimatedStyle: any
let useScrollViewOffset: any
let useSharedValue: any
let withTiming: any
let interpolate: any

if (Platform.OS !== 'web') {
    const reanimated = require('react-native-reanimated')
    Animated = reanimated.default
    useAnimatedRef = reanimated.useAnimatedRef
    useAnimatedStyle = reanimated.useAnimatedStyle
    useScrollViewOffset = reanimated.useScrollViewOffset
    useSharedValue = reanimated.useSharedValue
    withTiming = reanimated.withTiming
    interpolate = reanimated.interpolate
    CustomScroll = Animated.ScrollView
    CustomView = Animated.View
} else {
    CustomScroll = ScrollView
    CustomView = View
}

const { width, height } = Dimensions.get('window')
export const Gamification = () => {
    const isWeb = Platform.OS === 'web'
    const scrollViewRef = isWeb ? useRef<ScrollView>(null) : (useAnimatedRef as any)()
    const scrollOffset = isWeb ? { value: 0 } : (useScrollViewOffset as any)(scrollViewRef)
    const navigation = useNavigation()
    const insets = useSafeAreaInsets()
    const screenPercentage = height * 0.35
    const { prevFooterRoute, calledCustomBack, setCurrentFooterRoute } = getData()
    const {
        gamificationData,
        mapLoading,
        currentLevel,
        avatarUrl,
        backgroundGradient,
        ranking,
        parallaxImages,
        searchAndSendPendingGames,
        scrollUserLevel,
        mapHasRendered,
        setMapHasRendered,
        showRoulette,
        setShowRoulette,
        currentAnimatedIndex,
        setCurrentAnimatedIndex,
        setMapForUpdate,
    } = useGamification()
    const [dataSourceCords, setDataSourceCords] = useState([])
    const customCords = dataSourceCords

    // let isFocused: boolean = true
    const isFocused = !isWeb ? useIsFocused() : true

    const [continueAnimation, setContinueAnimation] = useState(false)

    useEffect(() => {
        let firstLoad = true
        if (!mapLoading) firstLoad = false
        searchAndSendPendingGames(firstLoad)
        eventEmitter.emit('hideFooter')
    }, [])

    useEffect(() => {
        if (mapHasRendered === true && isFocused) {
            if (gamificationData.levels.length > 0) {
                //Valido si el usuario ha alcanzado el último nivel
                let pendingLevels = gamificationData.levels.filter((level) => level.status != GAMIFICATION_STATUS_KEYS.COMPLETE)
                if (pendingLevels.length <= 5) {
                    setMapForUpdate()
                    setCurrentAnimatedIndex(0)
                    if (scrollViewRef && scrollViewRef.current) {
                        scrollViewRef?.current?.scrollTo({
                            x: 0,
                            y: 0,
                            animated: true,
                        })
                    }
                    searchAndSendPendingGames(true)
                }
            }

            setContinueAnimation(true)
            if (currentAnimatedIndex === null) {
                setCurrentAnimatedIndex(0)
            }
            setMapScroll()
        }
    }, [mapHasRendered, isFocused])

    useEffect(() => {
        if (isFocused) {
            updateRenderOnFocus(true)
        } else {
            if (mapHasRendered === true) {
                updateRenderOnFocus(false)
            }
        }
    }, [isFocused])

    function updateRenderOnFocus(focus = null) {
        if (mapHasRendered === null) {
            return
        }
        if (focus === true) {
            //Focus
            setMapHasRendered(true)
        } else {
            //Blur
            setMapHasRendered(false)
        }
    }

    const setMapScroll = async () => {
        await new Promise((resolve) => setTimeout(resolve, 1000))
        let scrollToLevels = await scrollUserLevel(currentLevel)

        for (let i = 0; i < scrollToLevels.length; i++) {
            scrollMap(scrollToLevels[i])
            await new Promise((resolve) => setTimeout(resolve, 1000))
        }
    }

    const scrollMap = async (scrollIndex: string) => {
        try {
            if (customCords.length > 0 && scrollViewRef.current) {
                let cord = customCords.find((cord) => cord[scrollIndex])?.[scrollIndex]
                if (cord === undefined) cord = 0
                let customYCords = cord - screenPercentage
                await scrollViewRef.current?.scrollTo({
                    x: 0,
                    y: customYCords,
                    animated: true,
                })
                return true
            } else {
                // scrollViewRef.current?.scrollToEnd({ animated: true })
                throw new Error('No se encontraron coordenadas para el scroll')
            }
        } catch (e) {
            // scrollMap(scrollIndex)
        }
    }
    const viewRanking = () => {
        navigation.navigate('GamificationRanking' as never)
    }
    const [selectedLevelID, setSelectedLevelID] = useState('')

    const openRoulette = (level_id) => {
        setSelectedLevelID(level_id)
        setShowRoulette(true)
    }
    const closeRoulette = () => {
        setSelectedLevelID('')
        setShowRoulette(false)
    }
    const rocketY = isWeb ? { value: 0 } : useSharedValue(0)

    const getRocketOffset = (byCurrentLevel) => {
        try {
            let l = 0
            if (byCurrentLevel) {
                let currentL = gamificationData.levels.find((level) => level._id === currentLevel)
                if (currentL === undefined) {
                    return 0
                }
                // Si el nivel actual es de tipo GAME, usar el id del anterior
                if (currentL.type?.type === GAMIFICATION_TYPES_KEYS.GAME) {
                    const idx = gamificationData.levels.findIndex((level) => level._id === currentLevel)
                    if (idx > 0) {
                        let prevL = gamificationData.levels[idx - 1]
                        let scrollIndex = prevL?._id || ''
                        // usar scrollIndex del anterior
                        let cord = customCords.find((cord) => cord[scrollIndex])?.[scrollIndex]
                        if (cord === undefined) cord = 0
                        let customYCords = cord
                        l = -customYCords
                        return l
                    }
                } else {
                    let scrollIndex = currentL?._id || ''
                    let cord = customCords.find((cord) => cord[scrollIndex])?.[scrollIndex]
                    if (cord === undefined) cord = 0
                    let customYCords = cord
                    l = -customYCords
                }
            } else {
                // if (gamificationData.levels > 0 && currentAnimatedIndex !== null) {
                let scrollIndex = gamificationData.levels[currentAnimatedIndex]?._id || ''
                let cord = customCords.find((cord) => cord[scrollIndex])?.[scrollIndex]
                if (cord === undefined) cord = 0
                let customYCords = cord
                l = -customYCords
            }
            return l
        } catch (e) {
            // console.error('Error getting rocket offset:', e)
            return 0
        }
    }

    let rocketOffset = getRocketOffset(true)
    useEffect(() => {
        if (mapHasRendered === true && isFocused && !isWeb) {
            rocketY.value = withTiming(rocketOffset, { duration: 2300 })
        }
    }, [rocketOffset, continueAnimation, mapHasRendered, isFocused])

    const rocketPosition = isWeb
        ? { transform: [{ scaleY: -1 }, { translateY: rocketOffset }] }
        : useAnimatedStyle(() => {
              return {
                  transform: [{ scaleY: -1 as any }, { translateY: rocketY.value as any }],
              } as any
          })
    if (mapLoading) {
        return <Loader />
    }

    return (
        <View style={{ flex: 1 }}>
            <LinearGradient colors={backgroundGradient} start={{ x: 0.5, y: 0 }} end={{ x: 0.5, y: 1 }} style={{ flex: 1 }}>
                <View
                    style={{
                        ...styles.infoHeader,
                        paddingTop: insets.top + 10,
                        backgroundColor: !showRoulette ? 'rgba(0, 0, 0, 0.5)' : 'transparent',
                    }}
                >
                    <View style={styles.backButtonContainer}>
                        <TouchableOpacity
                            style={styles.arrow}
                            onPress={() => {
                                eventEmitter.emit('showFooter')
                                navigation.navigate(prevFooterRoute as never)
                                setCurrentFooterRoute(prevFooterRoute)
                                calledCustomBack()
                            }}
                        >
                            <Ionicons name='arrow-back-outline' size={24} color={'white'} />
                        </TouchableOpacity>
                    </View>

                    <View style={styles.rankingButtonContainer}>
                        {ranking.length > 0 && (
                            <TouchableOpacity onPress={() => viewRanking()} style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <Ionicons name='trophy-outline' size={24} color={'white'} />
                            </TouchableOpacity>
                        )}
                    </View>
                </View>

                <GamificationAnimatedBackground offset={scrollOffset} parallaxImages={parallaxImages} />

                {/* Se utiliza scale -1 para invertir el item para scroll hacia arriba */}
                <CustomScroll
                    ref={scrollViewRef}
                    style={[styles.container, { transform: [{ scaleY: -1 }] }]}
                    scrollEventThrottle={16}
                    bounces={false}
                >
                    <View style={[styles.containerImage]}>
                        <View style={{ alignSelf: 'center', alignItems: 'center' }}>
                            {gamificationData.levels.map((item, index) => {
                                let currentLevelIndex = gamificationData.levels.findIndex(
                                    (level) => level.status === GAMIFICATION_STATUS_KEYS.PENDING,
                                )
                                let currentLevel = currentLevelIndex === index
                                let nextLevel = currentLevelIndex + 1 === index
                                return (
                                    <StepIndicatorCustom
                                        key={item._id}
                                        item={item}
                                        index={index}
                                        currentLevel={currentLevel}
                                        nextLevel={nextLevel}
                                        currentAnimatedIndex={currentAnimatedIndex}
                                        setCurrentAnimatedIndex={() => setCurrentAnimatedIndex(currentAnimatedIndex + 1)}
                                        continueAnimation={continueAnimation}
                                        setContinueAnimation={() => setContinueAnimation(false)}
                                        isFirstItem={index === 0}
                                        isLastItem={index === gamificationData.levels.length - 1}
                                        mapHasRendered={mapHasRendered}
                                        isFocused={isFocused}
                                        setMapHasRendered={(v) => {
                                            setMapHasRendered(v)
                                        }}
                                        customCords={customCords}
                                        dataSourceCords={dataSourceCords}
                                        setDataSourceCords={(c) => {
                                            setDataSourceCords(c)
                                        }}
                                        userLevel={gamificationData.userLevel}
                                        userPoints={gamificationData.points}
                                        avatarUrl={avatarUrl}
                                        openRoulette={openRoulette}
                                    />
                                )
                            })}
                            <CustomView
                                style={[
                                    {
                                        position: 'absolute',
                                        alignContent: 'center',
                                        justifyContent: 'center',
                                        alignSelf: 'center',
                                        alignItems: 'center',
                                    },
                                    rocketPosition,
                                ]}
                            >
                                <UserRocket avatarUrl={avatarUrl} />
                            </CustomView>
                        </View>
                        <View style={{ height: 30 }} />
                    </View>
                </CustomScroll>

                {showRoulette && (
                    <View style={{ flex: 1, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 100 }}>
                        <GamificationRoulette levelID={selectedLevelID} close={() => closeRoulette()} />
                    </View>
                )}
            </LinearGradient>
        </View>
    )
}
const StepIndicatorCustom = ({
    item,
    index,
    currentLevel = false,
    nextLevel = false,
    currentAnimatedIndex,
    setCurrentAnimatedIndex,
    continueAnimation,
    setContinueAnimation,
    isFirstItem,
    isLastItem,
    mapHasRendered,
    isFocused,
    setMapHasRendered,
    customCords,
    dataSourceCords,
    setDataSourceCords,
    userLevel,
    userPoints,
    avatarUrl,
    openRoulette,
}) => {
    if (item.type.type === GAMIFICATION_TYPES_KEYS.CONSTRUCTION) {
        return <></>
    }

    function isPair(index) {
        return index % 2 === 0
    }

    const [itemStatus, setItemStatus] = useState(currentAnimatedIndex <= index ? GAMIFICATION_STATUS_KEYS.BLOCKED : item.status)
    const animationTime = 150
    useLayoutEffect(() => {
        if (isFocused === false || mapHasRendered === false) return
        if (currentAnimatedIndex === index && continueAnimation === true) {
            // console.log('Item status updated for index:', index, 'with status:', item.status)
            setAnimationState()
        }
    }, [currentAnimatedIndex, mapHasRendered, isFocused, continueAnimation])

    const stepWidth = 8
    const stepHeight = 30
    const [topStepProgress, setTopStepProgress] = useState(0)
    const [bottomStepProgress, setBottomStepProgress] = useState(0)
    const [itemProgress, setItemProgress] = useState(0)

    async function setAnimationState() {
        if (currentAnimatedIndex > index) {
            //Item anterior
            setItemStatus(GAMIFICATION_STATUS_KEYS.PENDING)
            setBottomStepProgress(100)
            setTopStepProgress(100)
        }
        if (currentAnimatedIndex === index) {
            if (item.status === GAMIFICATION_STATUS_KEYS.BLOCKED) {
                setItemStatus(GAMIFICATION_STATUS_KEYS.BLOCKED)
                setBottomStepProgress(0)
                setItemProgress(0)
                setTopStepProgress(0)
            } else {
                await animateProgress(setBottomStepProgress, animationTime, async () => {
                    setItemStatus(item.status)
                    await animateProgress(setItemProgress, animationTime, async () => {
                        await animateProgress(setTopStepProgress, animationTime, () => {
                            if (item.status === GAMIFICATION_STATUS_KEYS.COMPLETE) {
                                setCurrentAnimatedIndex(index + 1)
                            }
                            if (item.status === GAMIFICATION_STATUS_KEYS.PENDING) {
                                setContinueAnimation(false)
                            }
                        })
                    })
                })
            }
        }
        if (currentAnimatedIndex < index) {
            //Item posterior
            setItemStatus(GAMIFICATION_STATUS_KEYS.BLOCKED)
            setBottomStepProgress(0)
            setTopStepProgress(0)
        }
    }
    const animateProgress = async (setProgressFn, duration, onComplete) => {
        const steps = 10
        const intervalTime = duration / steps
        let currentStep = 0

        const interval = setInterval(() => {
            currentStep++
            setProgressFn(currentStep * (100 / steps))

            if (currentStep >= steps) {
                clearInterval(interval)
                onComplete && onComplete()
            }
        }, intervalTime)
    }
    return (
        //Se utiliza scale -1 para invertir el item para scroll hacia arriba
        <View
            style={{ flexDirection: 'row', alignItems: 'center', transform: [{ scaleY: -1 }], width: width }}
            onLayout={(event) => {
                const layout = event.nativeEvent.layout
                dataSourceCords[index] = { [item._id]: layout.y }
                setDataSourceCords(dataSourceCords)
                if (index != customCords.length - 1) return
                setMapHasRendered(true)
            }}
        >
            {/* Texto a la Izq */}
            <View style={{ flex: 1, alignContent: 'center' }}>
                {isPair(index) && currentLevel === false && nextLevel === false && (
                    <LinearGradient
                        style={{
                            borderRadius: 20,
                            alignItems: 'center',
                            justifyContent: 'center',
                            alignSelf: 'flex-end',
                            marginRight: 25,
                            zIndex: 9,
                        }}
                        colors={
                            (item.status === GAMIFICATION_STATUS_KEYS.BLOCKED ? pointsGradientDisabled : pointsGradientEnabled) as readonly [
                                string,
                                string,
                            ]
                        }
                        start={{ x: 1, y: 0.5 }}
                        end={{ x: 0, y: 0.5 }}
                    >
                        <Text
                            style={{
                                color: GamificationTheme.stepPointsTextColor,
                                fontWeight: 'bold',
                                fontSize: 14,
                                marginVertical: 6,
                                marginHorizontal: 12,
                            }}
                        >
                            {item.points} pts
                        </Text>
                    </LinearGradient>
                )}
                {currentLevel === true && item.type.type != GAMIFICATION_TYPES_KEYS.GAME && (
                    <LinearGradient
                        style={{
                            borderRadius: 20,
                            alignItems: 'center',
                            justifyContent: 'center',
                            alignSelf: 'flex-end',
                            marginRight: 25,
                            paddingVertical: 3,
                            zIndex: 9,
                        }}
                        colors={pointsGradientCurrent as readonly [string, string, ...string[]]}
                        start={{ x: 1, y: 0.5 }}
                        end={{ x: 0, y: 0.5 }}
                    >
                        <Text
                            style={{
                                color: GamificationTheme.currentUserLevelTextColor,
                                fontWeight: 'bold',
                                fontSize: 14,
                                marginVertical: 6,
                                marginHorizontal: 18,
                            }}
                        >
                            Nivel: {userLevel}
                        </Text>
                    </LinearGradient>
                )}
            </View>

            {/* Contenido central */}
            <View style={{ alignItems: 'center' }}>
                {/* Linea vertical superior */}
                {currentAnimatedIndex <= index ? (
                    <Step
                        width={stepWidth}
                        heigth={stepHeight}
                        progress={item.status === GAMIFICATION_STATUS_KEYS.PENDING ? 0 : topStepProgress}
                        orientation={'vertical'}
                        fillColor={GamificationTheme.stepFillColor}
                        backgroundColor={GamificationTheme.stepUnfillColor}
                        roundStartCorners={false}
                        roundEndCorners={isLastItem}
                    />
                ) : (
                    <Step
                        width={stepWidth}
                        heigth={stepHeight}
                        progress={item.status === GAMIFICATION_STATUS_KEYS.COMPLETE ? 100 : 0}
                        orientation={'vertical'}
                        fillColor={GamificationTheme.stepFillColor}
                        backgroundColor={GamificationTheme.stepUnfillColor}
                        roundStartCorners={false}
                        roundEndCorners={isLastItem}
                    />
                )}

                <SetIndicator
                    key={item._id}
                    item={item}
                    itemStatus={itemStatus}
                    openRoulette={openRoulette}
                    avatarUrl={avatarUrl}
                    userPoints={userPoints}
                    nextLevel={nextLevel}
                    currentAnimation={index === currentAnimatedIndex}
                />

                {/* Linea vertical inferior */}
                {currentAnimatedIndex <= index ? (
                    <Step
                        width={stepWidth}
                        heigth={isFirstItem ? stepHeight + 20 : stepHeight}
                        progress={bottomStepProgress}
                        orientation={'vertical'}
                        fillColor={GamificationTheme.stepFillColor}
                        backgroundColor={GamificationTheme.stepUnfillColor}
                        roundStartCorners={isFirstItem}
                        roundEndCorners={false}
                    />
                ) : (
                    <Step
                        width={stepWidth}
                        heigth={isFirstItem ? stepHeight + 20 : stepHeight}
                        progress={item.status === GAMIFICATION_STATUS_KEYS.COMPLETE ? 100 : 0}
                        orientation={'vertical'}
                        fillColor={GamificationTheme.stepFillColor}
                        backgroundColor={GamificationTheme.stepUnfillColor}
                        roundStartCorners={false}
                        roundEndCorners={isLastItem}
                    />
                )}
            </View>

            {/* Texto a la Der */}
            <View style={{ flex: 1, alignContent: 'center' }}>
                {!isPair(index) && currentLevel === false && nextLevel === false && (
                    <LinearGradient
                        style={{
                            borderRadius: 20,
                            alignItems: 'center',
                            justifyContent: 'center',
                            alignSelf: 'flex-start',
                            marginLeft: 25,
                            zIndex: 9,
                        }}
                        colors={
                            (item.status === GAMIFICATION_STATUS_KEYS.BLOCKED ? pointsGradientDisabled : pointsGradientEnabled) as readonly [
                                string,
                                string,
                            ]
                        }
                        start={{ x: 0, y: 0.5 }}
                        end={{ x: 1, y: 0.5 }}
                    >
                        <Text
                            style={{
                                color: GamificationTheme.stepPointsTextColor,
                                fontWeight: 'bold',
                                fontSize: 14,
                                marginVertical: 6,
                                marginHorizontal: 12,
                            }}
                        >
                            {item.points} pts
                        </Text>
                    </LinearGradient>
                )}
                {currentLevel === true && item.type.type != GAMIFICATION_TYPES_KEYS.GAME && (
                    <LinearGradient
                        style={{
                            borderRadius: 20,
                            alignItems: 'center',
                            justifyContent: 'center',
                            alignSelf: 'flex-start',
                            marginLeft: 25,
                            paddingVertical: 3,
                            zIndex: 9,
                        }}
                        colors={pointsGradientCurrent as readonly [string, string, ...string[]]}
                        start={{ x: 0, y: 0.5 }}
                        end={{ x: 1, y: 0.5 }}
                    >
                        <Text
                            style={{
                                color: GamificationTheme.currentUserLevelTextColor,
                                fontWeight: 'bold',
                                fontSize: 14,
                                marginVertical: 6,
                                marginHorizontal: 18,
                            }}
                        >
                            {userPoints} pts
                        </Text>
                    </LinearGradient>
                )}
            </View>
        </View>
    )
}

const SetIndicator = ({ item, itemStatus, openRoulette, avatarUrl, userPoints, nextLevel, currentAnimation }) => {
    if (item === null || item === undefined) return

    let type = item.type?.type || 0
    let circleSize = width
    let borderColor = GamificationTheme.indicatorDefaultBorderColor
    let backgroundColor = GamificationTheme.indicatorDefaultBackgroundColor
    let autoHeigth = false
    let showBackImage = false
    let showSmallBackImage = false
    let view = null
    let showPoints = null
    let showRocket = false
    switch (type) {
        case GAMIFICATION_TYPES_KEYS.GAME:
            switch (itemStatus) {
                case GAMIFICATION_STATUS_KEYS.BLOCKED: // => -1
                    circleSize = 140
                    borderColor = GamificationTheme.gameLockedBorderColor
                    backgroundColor = GamificationTheme.gameLockedBackgroundColor
                    showPoints = { isGame: true }
                    view = (
                        <ImageBackground
                            source={require('../../../assets/gamification/pointsLocked.png')}
                            style={{ width: 140, height: 140, alignItems: 'center' }}
                        >
                            <Text style={{ color: GamificationTheme.gameLockedTextColor, marginTop: 40, fontSize: 22, fontWeight: '500' }}>
                                {'nv ' + item.level_text}
                            </Text>
                        </ImageBackground>
                    )
                    break
                case GAMIFICATION_STATUS_KEYS.COMPLETE: // => 1
                    circleSize = 160
                    borderColor = 'transparent'
                    backgroundColor = 'transparent'
                    view = (
                        <ImageBackground
                            source={require('../../../assets/gamification/pointsUnlocked.png')}
                            style={{ width: 180, height: 180, alignItems: 'center', alignContent: 'center' }}
                        >
                            <Text
                                style={{
                                    color: GamificationTheme.gameCompleteTextColor,

                                    fontSize: 24,
                                    fontWeight: '500',

                                    marginTop: 60,
                                }}
                            >
                                {item.level_text}
                            </Text>
                        </ImageBackground>
                    )
                    break
                default: // GAMIFICATION_STATUS_KEYS.PENDING => 0
                    circleSize = width / 2
                    borderColor = 'transparent'
                    backgroundColor = 'transparent'
                    autoHeigth = true
                    showBackImage = false
                    view = (
                        <TouchableWithoutFeedback
                            onPress={() => openRoulette(item._id)}
                            style={{
                                width: circleSize,
                                alignContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <View style={{ alignContent: 'center', alignItems: 'center', marginTop: -30 }}>
                                <ImageBackground
                                    source={require('../../../assets/gamification/JackpotRayos.png')}
                                    style={{ width: width, height: circleSize, alignContent: 'center', alignItems: 'center', zIndex: 3 }}
                                >
                                    <Image
                                        source={require('../../../assets/gamification/jackpot.gif')}
                                        style={{
                                            width: width - 60,
                                            height: circleSize,
                                        }}
                                        cachePolicy='memory'
                                        allowDownscaling={true}
                                    />
                                </ImageBackground>
                                <View
                                    style={{
                                        flexDirection: 'row',
                                        backgroundColor: GamificationTheme.gamePendingGradientBackgroundColor,
                                        borderRadius: 20,
                                        width: width - 104,
                                    }}
                                >
                                    <LinearGradient
                                        colors={JackPotGradient as readonly [string, string]}
                                        start={{ x: 0, y: 0.5 }}
                                        end={{ x: 1, y: 0.5 }}
                                        style={{ flex: 1, margin: 6, borderRadius: 15, height: 56, alignContent: 'center', justifyContent: 'center' }}
                                    >
                                        <Text style={[styles.playGame, { alignSelf: 'center', paddingBottom: 5 }]}>¡JUGA Y PASA DE NIVEL!</Text>
                                    </LinearGradient>
                                </View>
                                <View style={{ marginTop: -15, marginBottom: -5, height: 60, alignContent: 'center' }}>
                                    <View
                                        style={[
                                            styles.scoreBox,
                                            {
                                                flexDirection: 'row',
                                                alignContent: 'center',
                                                alignItems: 'center',
                                            },
                                        ]}
                                    >
                                        <Text
                                            style={[
                                                styles.gameLevel,
                                                {
                                                    textAlign: 'center',
                                                    marginEnd: 45,
                                                },
                                            ]}
                                        >
                                            Nivel {item.level_text}
                                        </Text>
                                        <Text
                                            style={[
                                                styles.gameLevel,
                                                { color: GamificationTheme.gamePendingPointsTextColor, textAlign: 'center', marginStart: 45 },
                                            ]}
                                        >
                                            {userPoints} pts
                                        </Text>
                                    </View>
                                    <Image source={{ uri: avatarUrl }} style={[styles.userImage, { position: 'absolute', alignSelf: 'center' }]} />
                                </View>
                            </View>
                        </TouchableWithoutFeedback>
                    )
                    break
            }
            break
        case GAMIFICATION_TYPES_KEYS.CONSTRUCTION:
            circleSize = 0
            switch (itemStatus) {
                case GAMIFICATION_STATUS_KEYS.BLOCKED: // => -1
                    borderColor = 'transparent'
                    backgroundColor = 'transparent'
                    view = <></>
                    break
                case GAMIFICATION_STATUS_KEYS.COMPLETE: // => 1
                    borderColor = 'transparent'
                    backgroundColor = 'transparent'
                    view = <></>
                    break
                default: // GAMIFICATION_STATUS_KEYS.PENDING => 0
                    borderColor = 'transparent'
                    backgroundColor = 'transparent'
                    view = <></>
                    break
            }
            break
        default: //Dot
            circleSize = 52
            if (item.status === GAMIFICATION_STATUS_KEYS.PENDING) {
                borderColor = 'transparent'
                circleSize = 100
                backgroundColor = 'transparent'
                borderColor = 'transparent'
                autoHeigth = true
                view = (
                    <View style={{ marginVertical: -40, width: 128, height: 230, alignContent: 'center', alignItems: 'center', zIndex: -1 }}>
                        <Step
                            width={8}
                            heigth={195}
                            progress={0}
                            orientation={'vertical'}
                            fillColor={GamificationTheme.stepFillColor}
                            backgroundColor={GamificationTheme.stepUnfillColor}
                            roundStartCorners={false}
                            roundEndCorners={false}
                        />
                    </View>
                )
                break
            }
            switch (itemStatus) {
                case GAMIFICATION_STATUS_KEYS.BLOCKED: // => -1
                    borderColor = GamificationTheme.dotBlockedBorderColor
                    if (!nextLevel) {
                        view = <Feather name='lock' size={24} color={GamificationTheme.dotBloquedIconColor} />
                    } else {
                        circleSize = 120
                        showSmallBackImage = true
                        showPoints = { isGame: false }
                        view = (
                            <Image
                                source={require('../../../assets/gamification/nextLevelLock.png')}
                                style={{ width: 72, height: 72 }}
                                contentFit='contain'
                            />
                        )
                    }
                    break
                case GAMIFICATION_STATUS_KEYS.COMPLETE: // => 1
                    borderColor = 'white'
                    backgroundColor = GamificationTheme.dotCompleteBackgroundColor
                    view = <Feather name='check' size={24} color={GamificationTheme.dotCompleteIconColor} />
                    break
                default: // GAMIFICATION_STATUS_KEYS.PENDING => 0
                    borderColor = 'transparent'
                    circleSize = 100
                    backgroundColor = 'transparent'
                    borderColor = 'transparent'
                    autoHeigth = true
                    view = (
                        <View style={{ marginVertical: -40, width: 128, height: 230, alignContent: 'center', alignItems: 'center', zIndex: -1 }}>
                            <Step
                                width={8}
                                heigth={195}
                                progress={0}
                                orientation={'vertical'}
                                fillColor={GamificationTheme.stepFillColor}
                                backgroundColor={GamificationTheme.stepUnfillColor}
                                roundStartCorners={false}
                                roundEndCorners={false}
                            />
                        </View>
                    )
                    break
            }
            break
    }
    return (
        <View style={{ justifyContent: 'center', alignItems: 'center', zIndex: 6 }}>
            {showSmallBackImage && (
                <Image
                    source={require('../../../assets/gamification/nextLevelLights.png')}
                    style={{
                        width: 220,
                        height: 220,
                        zIndex: 0,
                        backgroundColor: 'transparent',
                        position: 'absolute',
                        alignSelf: 'center',
                    }}
                />
            )}
            <View
                style={{
                    width: circleSize,
                    height: autoHeigth === true ? null : circleSize,
                    borderRadius: circleSize / 2,
                    borderWidth: 6,
                    borderColor: borderColor,
                    backgroundColor: backgroundColor,
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1,
                    shadowColor: 'black',
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.25,
                    shadowRadius: 3.84,
                }}
            >
                {showBackImage && (
                    <Image
                        source={require('../../../assets/gamification/JackpotRayos.png')}
                        style={{ width: width, height: width, zIndex: 0, alignContent: 'center', alignItems: 'center', position: 'absolute' }}
                        contentFit='cover'
                    />
                )}
                {/* {showRocket && (
                    <Image
                        source={require('../../../assets/gamification/rocket.gif')}
                        style={{ width: 256, height: 268, zIndex: 0, alignContent: 'center', alignItems: 'center', position: 'absolute' }}
                        contentFit='contain'
                    />
                )} */}
                {view}
            </View>
            {showPoints && (
                <>
                    {showPoints.isGame === false ? (
                        <View
                            style={{
                                borderWidth: 6,
                                borderColor: borderColor,
                                backgroundColor: backgroundColor,
                                borderRadius: 30,
                                zIndex: 0,
                                marginTop: -7,
                            }}
                        >
                            <Text style={{ fontWeight: '700', color: 'white', marginHorizontal: 15, marginVertical: 3 }}>{item.points + ' pts'}</Text>
                        </View>
                    ) : (
                        <View style={{ zIndex: 2, marginTop: -60, alignItems: 'center' }}>
                            <Image source={require('../../../assets/gamification/gameLock.png')} style={{ width: 40, height: 40, zIndex: 1 }} />
                            <ImageBackground
                                source={require('../../../assets/gamification/gameLockBackground.png')}
                                resizeMode='stretch'
                                style={{ marginTop: -10 }}
                            >
                                <Text
                                    style={{
                                        fontWeight: '500',
                                        color: 'black',
                                        marginHorizontal: 20,
                                        marginVertical: 10,
                                    }}
                                >
                                    {item.points}
                                    <Text style={{ fontWeight: '300' }}> pts</Text>
                                </Text>
                            </ImageBackground>
                        </View>
                    )}
                </>
            )}
        </View>
    )
}

const UserRocket = ({ avatarUrl }) => {
    return (
        <ImageBackground
            source={require('../../../assets/gamification/rocket.gif')}
            style={{
                width: 128,
                height: 220,
                zIndex: 0,
                justifyContent: 'center',
                paddingBottom: 10,
            }}
        >
            <Image
                source={{ uri: avatarUrl }}
                style={{
                    width: 60,
                    height: 60,
                    borderRadius: 30,
                    borderWidth: 3,
                    borderColor: GamificationTheme.userImageBorderColor,
                    opacity: 1,
                    alignSelf: 'center',
                    justifyContent: 'center',
                }}
                cachePolicy='memory'
            />
        </ImageBackground>
    )
}
